import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { find, map } from 'lodash-es';
import { ReactNode, useState } from 'react';

import { MultiSelectProps } from './SelectCommon';

export interface MultiSelectGenericProps<T> extends MultiSelectProps<T> {
	getOptionText: (item: T) => ReactNode;
	getOptionValue: (item: T) => string;
}

export const MultiSelectGeneric = <T,>(props: MultiSelectGenericProps<T>) => {
	const [internalValue, setValue] = useState<string[] | T[]>(
		props.selectedOptions
	);
	const initialValue =
		internalValue === undefined
			? []
			: map(internalValue, (item) => props.getOptionValue(item as T));

	const handleChange = (event: SelectChangeEvent<typeof internalValue>) => {
		const {
			target: { value },
		} = event;
		const newValue = typeof value == 'string' ? [value] : value;

		const items = map(
			newValue,
			(key) =>
				find(
					props.options,
					(item) => props.getOptionValue(item) === key
				) as T
		);

		setValue(items);
		props.onChange(items);
	};

	const regex = /[^A-Za-z0-9]+/;
	const labelId =
		props.label === undefined || props.id === undefined
			? ''
			: `select-label-${props.id}-${props.label.replace(regex, '')}`;

	return (
		<span id={props.id} className={props.className}>
			<FormControl sx={{ width: 300 }}>
				<InputLabel id={labelId}>{props.label}</InputLabel>
				<Select
					labelId={labelId}
					multiple
					value={initialValue}
					onChange={handleChange}
					input={<OutlinedInput label={props.label} />}>
					{props.options.map((item: T, index: number) => (
						<MenuItem
							key={index}
							value={props.getOptionValue(item)}>
							{props.getOptionText(item)}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</span>
	);
};
